import {useMemo} from 'react'

import {useAppSelector} from '../../../../../../../../hooks/react-redux'
import {getEmptyHash} from '../../../../../../../../utils/empty'
import {usePipelineId} from '../../../../../hooks/pipeline'
import {getDraft} from '../../../../EditPipelinePage.selectors'

function usePipelineSecretErrorMessages(originalName: string) {
  const id = usePipelineId()
  const parameters: Record<string, string | undefined> = useAppSelector(
    state => getDraft(state, id)?.settings.parameters ?? getEmptyHash(),
  )
  const secrets: Record<string, string | undefined> = useAppSelector(
    state => getDraft(state, id)?.settings.secrets ?? getEmptyHash(),
  )
  const compareSecretsArray = useMemo(
    () => Object.keys(secrets).filter(key => key !== originalName),
    [secrets, originalName],
  )
  const compareParamsArray = useMemo(() => Object.keys(parameters), [parameters])
  const compareValidatorArray = [...compareSecretsArray, ...compareParamsArray]

  return {
    compareValidatorArray,
  }
}

export default usePipelineSecretErrorMessages
